import React, { useState, useEffect, useRef} from 'react';
import io from 'socket.io-client';
import Login from './components/Login';
import HelpChat from './components/HelpChat';
import ChatRoom from './components/ChatRoom';
import ChatRoomsList from './components/ChatRoomsList';
import Graph from './components/graph/Graph';
import createTempDemoSpace from './demoTrick'
import './App.css';
import AccountSettingsForm from './components/AccountSettingsForm';
import { Buffer } from 'buffer';

// require('dotenv').config({ path: '/client/.env' });

    let protocol = process.env.REACT_APP_PROTOCOL
    if (protocol === undefined){
      protocol = "http"
    }
    console.log('using app server call protocol : ' + protocol)

    let hosturl = process.env.REACT_APP_ALTAIEGO_HOST
    if (hosturl === undefined) {
      hosturl = window.location.hostname
    }
    console.log('using host ' + hosturl)

    let socket_options = {
            reconnection: true, // Activer la reconnexion automatique
            reconnectionAttempts: Infinity, // Nombre de tentatives de reconnexion
            reconnectionDelay: 1000, // Délai entre les tentatives de reconnexion (en ms)
            timeout: 20000, // Timeout pour la connexion
    }

    if (protocol === 'https') {
      socket_options = {
          reconnection: true, // Activer la reconnexion automatique
          reconnectionAttempts: Infinity, // Nombre de tentatives de reconnexion
          reconnectionDelay: 1000, // Délai entre les tentatives de reconnexion (en ms)
          timeout: 20000, // Timeout pour la connexion
          // ca: Buffer.from(process.env.REACT_APP_SSL_CA_CONTENT, 'base64').toString('utf8'),
          // cert: Buffer.from(process.env.REACT_APP_SSL_CERT_CONTENT, 'base64').toString('utf8'),
          // key: Buffer.from(process.env.REACT_APP_SSL_KEY_CONTENT, 'base64').toString('utf8'),
          ca: process.env.REACT_APP_SSL_CA_PATH,
          cert: process.env.REACT_APP_SSL_CERT_PATH,
          key: process.env.REACT_APP_SSL_KEY_PATH,
          rejectUnauthorized: process.env.REACT_APP_NODE_ENV === 'production',
          secure: true
        }
      }

    console.log('Starting client in ' + protocol);
    const socket = io(protocol + '://' + hosturl + ':3050', socket_options)





socket.on('connect', () => {
  console.log('Connecté au serveur');
  // Le client peut maintenant envoyer des données
});

socket.on('disconnect', () => {
  console.log('Déconnecté du serveur');
});

socket.on('error', (error) => {
  console.error('Erreur lors de l\'envoi de la socket :', error);
});




function App() {
  const [uid, setUid] = useState('');
  const [login, setLogin] = useState('')
  const tempLogin = useRef('')
  const [username, setUsername] = useState('')
  const [userPseudo, setUserpseudo] = useState('');
  const [userDescription, setUserdescription] = useState('');
  const [currentRoom, setCurrentRoom] = useState('');
  const currentRoomRef = useRef(currentRoom)
  const fixedRoomRef = useRef(false)
  const [currentRoomType, setCurrentRoomType] = useState('');
  const [mapName, setMapName] = useState('');
  const [roomType, setRoomType] = useState('');
  const [graphRatio, setGraphRatio] = useState(1);
  const [graphWidth, setGraphWidth] = useState(50);
  const [graphHeight, setGraphHeight] = useState(800);
  const pastMessages = useState([]);
  const [pointedMessage, setPointedMessage] = useState();
  const [splitPosition, setSplitPosition] = useState(98);
  const [isMobile, setIsMobile] = useState(window.innerHeight < 400 || window.innerWidth < 400);
  const [isOwner, setIsOwner] = useState(false);
  const [isCoach, setIsCoach] = useState(false);
  const [roomList, setRoomList] = useState([])
  const [messages, setMessages] = useState(new Map());
  const [mmNodes, setMMNodes] = useState([]);
  const [mmLinks, setMMLinks] = useState([]);
  const [last_live_message_id, setLastLiveMessageId] = useState('')
  const [startDate, setStartDate] = useState(null)
  const [minThreshold, setMinThreshold] = useState(0.9);

  const [app_visible, setAppVisible] = useState(true)
  const [image_content, setImageContent] = useState(false)
  const [pdf_content, setPdfContent] = useState(false)
  const [doc_content, setDocContent] = useState(false)
  const [blog_content, setBlogContent] = useState(false)
  const [contentUrl, setContentUrl] = useState('')
  const [docUrl, setDocUrl] = useState('')
  const [mainUrl, setMainUrl] = useState('')
  const [activePane, setActivePane] = useState("graph"); // 'graph' ou 'share'
  const tmpLogin = useRef(null)
  const empty_mindmap = {nodes : [], links : []};
  const updateMultipleRoomList = (rl) => {
      if (fixedRoomRef.current) return
      setRoomList(rl)
  }

  const logo_url = protocol + '://' + hosturl + ':3050/images/logo.png'

  const handleSplitMouseMove = (e) => {
    const svg = document.querySelector('#graphPositioner'); // ou via ref React
    //if (svg !== undefined) {
    //  svg.style.pointerEvents = 'none';
    // }
    const mainDiv = document.getElementById('chat_app')
    const containerWidth = isMobile ? mainDiv.offsetHeight : mainDiv.offsetWidth;
    const newSplitPosition = Math.max( ((isMobile ? e.clientY : e.clientX) / containerWidth) * 100, 5);
    // const newSplitPosition = Math.max(e.clientX , 10);
    // const newSplitPosition = 90;
    //console.log('container width: ' + containerWidth)
    //console.log('x position: ' + e.clientX)
    //console.log('ratio: ' + e.clientX / containerWidth)

    // console.log('new position: ' + newSplitPosition)
    setSplitPosition(newSplitPosition);
  };

  const handleSplitMouseUp = () => {
    document.removeEventListener('mousemove', handleSplitMouseMove);
    document.removeEventListener('pointermove', handleSplitMouseMove);
    document.removeEventListener('mouseup', handleSplitMouseUp);
    document.removeEventListener('pointerup', handleSplitMouseUp);
    const svg = document.querySelector('#graphPositioner'); // ou via ref React
    if (svg !== undefined) {
      svg.style.pointerEvents = '';
    }
  };

  const handleSplitMouseDown = (e) => {
        const svg = document.querySelector('#graphPositioner'); // ou via ref React
    //if (svg !== undefined) {
    //  svg.style.pointerEvents = 'none';
    //}

    if (isMobile) {
      return
    }
    document.addEventListener('mousemove', handleSplitMouseMove);
    document.addEventListener('pointermove', handleSplitMouseMove);
    document.addEventListener('mouseup', handleSplitMouseUp);
    document.addEventListener('pointerup', handleSplitMouseUp);
  };

  function   setLastMessageId(id) {
       setLastLiveMessageId(id)
  }
  
  function scrollMessagesInRoom(message) {
    // console.log('scroll to message : ' + JSON.stringify(message))
    if (!isCoach){
      setPointedMessage(null)
      return
    }
    if (messages.size > 0) {
      const sortedMessageEntries = Array.from(messages.entries()).sort((a, b) => a[0] - b[0])
      const last_message = sortedMessageEntries.at(-1)
      if (last_message[0] === message) {
        setPointedMessage(null)
      }else {
        setPointedMessage(message)
     }
    } 
  }

  useEffect(() => {

    const pathname = window.location.pathname
    if (pathname.startsWith('/images/')){
        const imUrl = protocol + '://' + hosturl + ':3050' + pathname
        setContentUrl(imUrl)
        setDocUrl('')
        setMainUrl('')
        setAppVisible(false)
        setImageContent(true)
    } else if (pathname === '/') {
        const docUrl = protocol + '://' + hosturl + ':3050/index.html'
        const imUrl = protocol + '://' + hosturl + ':3050/images/logo.png'

        setDocUrl('')
        setMainUrl(docUrl)
        setContentUrl(imUrl)
        setPdfContent(false)
        setAppVisible(true)
        setDocContent(false)
        if (login !== '' ||  currentRoom !== '') {
          setImageContent(false)
        } else {
          setImageContent(true)
        }
    } else if (pathname === '/docs/index.html') {
        const imUrl = protocol + '://' + hosturl + ':3050/docs/main.pdf'
        setContentUrl(imUrl)
        setMainUrl('')
        setDocContent(false)
        setPdfContent(false)
        setAppVisible(false)
        setImageContent(true)
    } else if (pathname.startsWith('/docs/')) {
        const imUrl = protocol + '://' + hosturl + ':3050/docs/' + pathname.split('/')[-1]
        setContentUrl(imUrl)
        setDocContent(false)
        setPdfContent(false)
        setMainUrl('')
        setAppVisible(false)
        setImageContent(true)
    } else if (pathname.startsWith('/export_docs/')) {
        const spritz = pathname.split('/')
        const docName = spritz[spritz.length -1]
        const imUrl = protocol + '://' + hosturl + ':3050/export_docs/' + docName
        setContentUrl(imUrl)
        setDocContent(false)
        setMainUrl('')
        setPdfContent(true)
        setAppVisible(false)
        setImageContent(false)
    } else {
        setMainUrl('')
        setImageContent(false)
        setPdfContent(false)
        setDocContent(false)
        setBlogContent(false)
    }

    const searchParams = new URLSearchParams(window.location.search);
    for (let [key, value] of searchParams.entries()) {
            console.log(key + ' : ' + value)
            if (key === 'login') {
              setLogin(value)
            }
            if (key === 'demo') {
              const new_login = Date.now().toString()
              if (tempLogin.current === '' || (parseInt(new_login) - parseInt(tempLogin.current) > 900000000)) { // un quart d'heur d'attente
                tempLogin.current = new_login
                if (searchParams.has('map')) {
                    createTempDemoSpace(socket, new_login, searchParams.get('map'))
                }
                createTempDemoSpace(socket, new_login)
              }
            }
            if (key === 'salle') {
              setCurrentRoom(value)
              fixedRoomRef.current = true
              currentRoomRef.current = value
            }
    }

    const handleResize = () => {
      setIsMobile(window.innerWidth < 400 || window.innerHeight < 400);
    };

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, [login]);
  

    socket.on('created demo space', (message) => {
      console.log('Demo created :', message.login);
      setLogin(message.tempLogin + "@demo")
      setCurrentRoom(message.tempRoom)
    });

  useEffect(() => {
    // Setup socket listeners
    socket.on('message', (message) => {
      console.log('Message received:', message);
    });

    // Cleanup on unmount
    return () => {
      socket.off('message');
    };
  }, []);

   
  const handleLogin = (user_id, user_name, sRoom) => {
    setUid(user_id)
    setUsername(user_name);
    setCurrentRoom(sRoom)
    setImageContent(false)
    setBlogContent(false)
    setDocContent(false)
    currentRoomRef.current = sRoom
  };

 const handleVoiceMe = () => {

  };

  const handleLogout = () => {
    socket.emit('logout', {uid})
    setUsername('');
    setUid('')

   };

  useEffect(() =>  {

    socket.on('manageUserForm', (u) => {
      setUserpseudo('')
      const uuf = document.getElementById('user_update_form')
      if (uuf !== null)
        return
      const mu = JSON.parse(u)

      if (mu.user_id !== uid )
        return
      const user_description = mu.description
      const user_pseudo = mu.pseudo
      setUserpseudo(user_pseudo)
      setUserdescription(user_description)
    });


  },[uid, userPseudo, userDescription])

  useEffect(() => {
    socket.on('room joined', (roomId, description, parentMessage, point_message, user, mmap, map_name, room_type, is_owner, is_coach) => {
      if ((user === uid) || (user === 'leaded move')) {
        setCurrentRoom(roomId)
        setCurrentRoomType(room_type)
        setIsOwner(is_owner)
        setIsCoach(is_coach)
        setMapName(map_name === 'None' ? ' ;-' : map_name)
        setRoomType(room_type)
        currentRoomRef.current = roomId
      }
  });

  }, [uid, isOwner, isCoach, currentRoom])


function hideTooltipWhenOut() {
  const left = document.querySelector('#left-panel'); // ta div D3
  const graph = document.querySelector('#graphContainer'); // ta div D3
  const tooltip = document.querySelector('#tooltip');
  if (tooltip !== null && left !== null) {
      left.addEventListener('mouseenter', () => {
        tooltip.style.visibility = 'hidden'
      });
  }
  if (tooltip !== null && graph !== null) {
      graph.addEventListener('mouseenter', () => {
        tooltip.style.visibility = 'visible'
        tooltip.style.opacity = 0
      });
  }

}

  const mainUrlP1 = mainUrl + "#page=1&toolbar=0&navpanes=0"


  
  const observer = new ResizeObserver(entries => {
  for (let entry of entries) {
    const { width, height } = entry.contentRect;
    setGraphRatio(width / height)
    setGraphWidth(width)
    setGraphHeight(height)
    // updateTree(width, height); // réajuste ton layout D3
  }
});

const graphContainer = document.getElementById('semantic_panel')
if (graphContainer){
  observer.observe(graphContainer);
}


  return (
  <div className='main_display no-select' width="100%">
      {doc_content && !(login !=='' && currentRoom !== '')? <a href="/export_docs/GO_Utilisateur_final_Utilisation_finale_CUF_V1.0_FINAL.pdf" target="EC_docs"><img className='logo_display' title='En savoir plus' src={contentUrl}/></a>  : '' } 
      {pdf_content && !(login !=='' && currentRoom !== '')? <><img className='image_display' title='En savoir plus' src={logo_url} /><iframe class='main_page_frame' src={contentUrl} width="100%" height="100%"></iframe></>
 : ''}
      {(mainUrl != '' && !(login !=='' && currentRoom !== '')) ?  <div className={`main_page_index ${isMobile ? 'mobile' : ''}`}><iframe class='main_page_frame' src={mainUrl}></iframe>
</div> : ''}
       {image_content && !(login !=='' && currentRoom !== '')? <img className='image_display' title='En savoir plus' src={contentUrl}/> : ''}
     
      {doc_content && !(login !=='' && currentRoom !== '')? <a href="/index.html"><img className='Web_page' title='Pourquoi, pour qui ?' src={docUrl}/></a>  : ''}
      {blog_content && !(login !=='' && currentRoom !== '')? '' : ''}
      <div className="App" id='chat_app'>
      {app_visible && username && hosturl !== null && socket !== null ? (
        <div class="app_panel">
          {userPseudo !== '' ? (
          <AccountSettingsForm uid={uid} pseudo={userPseudo} description={userDescription} channel={socket} 
                            setUserpseudo={setUserpseudo} onLogout={handleLogout} />
          ) : (
            <div id='main' className="chat-container">
            <div className='chat-menus'>
            {isMobile && (
              <div className="mobile-switch">
                <button
                  onClick={() => setActivePane("chat")}
                  className={`tab-button ${activePane === "chat" ? "active" : ""}`}
                  >
                  Messages
                </button>
                <button
                  onClick={() => setActivePane("graph")}
                  className={`tab-button ${activePane === "graph" ? "active" : ""}`}
                  >
                  Graphe
                </button>
              </div>
            )}
            <HelpChat uid={uid} server_host={hosturl} username={username} roomId='help' 
                      channel={socket} onVoiceMe={handleVoiceMe} 
                        onLogout={handleLogout} 
                        is_owner={isOwner} is_coach={isCoach} />
            </div>
            <ChatRoomsList uid={uid} channel={socket} roomList={roomList} 
                          server_host={hosturl}
                          selectedRoom={currentRoom}
                          setRoomList={updateMultipleRoomList}/>
            <div className='chat-double-panel'>
            {(isCoach || roomType === 'boussole')? (
          <div id="left-panel" className={`room-panel left-panel ${isMobile && activePane === 'graph' ? 'hidden' : 'visible'} ${isMobile ? 'mobile' : ''}`}  
                  style={{ flexGrow: isMobile ?  activePane === 'graph' ? 0 : 100 : (splitPosition) / 100, 
                          height : '93%'
                        }}>
            {currentRoom ?(
            <ChatRoom roomId={currentRoom} 
                      u_id={uid} 
                      username={username} 
                      mapName={mapName}
                      roomType={currentRoomType}
                      socket={socket} 
                      mmNodes={mmNodes} 
                      startDate={startDate}
                      server_host={hosturl}
                      scrollMessages={scrollMessagesInRoom}
                      lastLiveMessageId={last_live_message_id}
                      setLastLiveMessageId={setLastMessageId}
                      pointed_message={pointedMessage}
                      messages={messages}
                      graphRatio={graphRatio} graphWidth={graphWidth} graphHeight={graphHeight} 
                      setMessages={setMessages}
                      minThreshold={minThreshold}
                      is_owner={isOwner}
                      is_coach={isCoach}
                      isMobile={isMobile} />) :( ' ')}
          </div>
           ) : (
            <div id="left-panel" className="room-panel left-panel"  
            style={{
                    flexGrow: 1 , 
                    flexDirection: isMobile ? 'column' : 'row',
                    height : '100%'
                  }}>

            {currentRoom ?(

              <ChatRoom roomId={currentRoom} 
                u_id={uid} 
                username={username} 
                socket={socket} 
                past_messages={pastMessages} 
                startDate={startDate}
                server_host={hosturl}
                scrollMessages={scrollMessagesInRoom}
                pointed_message={pointedMessage}
                messages={messages}
                setMessages={setMessages}
                is_owner={isOwner}
                is_coach={isCoach} />) : (' ')}
    </div>
          )}
          {(isCoach || currentRoomType === 'boussole') && (!isMobile) ?(
          <div className="split-handle no-select"  onMouseDown={handleSplitMouseDown} onPointerDown={handleSplitMouseDown}
          style={{    display:'flex',
                      flexGrow: 0.01, 
                      cursor: 'ew-resize',
                      flexDirection: 'row',
                      width: '1px', height : '68%' , left :'2px',  top : '14%'}}>
                    {/* Séparateur */}
          </div>
                    ) : ( ' ')}
          {(isCoach || currentRoomType === 'boussole') && currentRoom !== '' ? (

          <div id="semantic_panel" className={`chat-panel right-panel ${isMobile && activePane === 'chat' ? 'hidden' : 'visible'} ${isMobile ? 'mobile' : ''}`}
                style={{height : '98%',  flexGrow: isMobile ?  activePane === 'chat' ? 0 : 100 :  (100 - splitPosition) / 100, flexDirection: isMobile ? 'column' : 'row'}}>
            <Graph uid={uid} room={currentRoomRef.current} channel={socket} 
                    map_name={mapName} scrollMessages={scrollMessagesInRoom}
                    pMessage={pointedMessage} last_live_message_id={last_live_message_id}
                    mmNodes={mmNodes}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    graphRatio={graphRatio ** 1.7} graphWidth={graphWidth} graphHeight={graphHeight} 
                    setMMNodes={setMMNodes}
                    mmLinks={mmLinks}
                    minThreshold={minThreshold}
                    setMinThreshold={setMinThreshold}
                    isOwner={isOwner}
                    isCoach={isCoach}
                    isMobile={isMobile}
                    setMMLinks={setMMLinks} 
                    hideTooltipWhenOut={hideTooltipWhenOut}/>
            <div id="tooltip" width="0%" className='tooltip'>
              <p className='tooltip_header'>header</p>
              <p className='tooltip_info'>info</p>
              <p className='tooltip_refs'></p>
      </div>

          </div>
          ) : ( ' ')}
          </div>
          </div>
        )}
          </div>
      ) : ('')}
      {app_visible && (! username ||  hosturl === null || socket === null) && (currentRoom !== '' || login !== '')? (
        <Login socket={socket} server_host={hosturl} login={login} roomId={currentRoom} onLogin={handleLogin} />
      ) : ('')}

    </div>
  </div>
  );
}

export default App;